import { CancelIcon } from '@treneo/shared/icons';

import { Alert } from './alert';

type Props = {
  text?: string;
  children?: React.ReactNode;
};

export const AlertError = ({ text, children }: Readonly<Props>) => (
  <Alert severity='error' icon={<CancelIcon />}>
    {children ?? text}
  </Alert>
);
